import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

import common from "./locales/he/common.json";
import resus from "./locales/he/resus.json";
import protocols from "./locales/he/protocols.json";
import homePage from "./locales/he/home_page.json";
import hematologyEn from "./locales/en/hematology.json";
import hematologyHe from "./locales/he/hematology.json";

// Get language from URL parameter
const getLanguageFromUrl = () => {
	const params = new URLSearchParams(window.location.search);
	return params.get("lang") || "he"; // Default to Hebrew if no language parameter
};

export const defaultNS = "common";
export const resources = {
	en: {
		hematology: hematologyEn,
	},
	he: {
		common,
		resus,
		protocols,
		homePage,
		hematology: hematologyHe,
	},
} as const;

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.use(
		resourcesToBackend(
			(language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)
		)
	)
	.init({
		lng: getLanguageFromUrl(),
		fallbackLng: "he",
		supportedLngs: ["he", "ar", "en"],
		ns: ["common", "resus", "protocols", "homePage", "hematology"],
		resources: resources,
		defaultNS: defaultNS,
		interpolation: {
			escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
		},
		detection: {
			order: ["querystring", "navigator"],
			lookupQuerystring: "lang",
		},
	});

export default i18n;
